import './styles/reset.css';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web/lib/provider';
import { Preloader } from 'ksnm-common-ui/lib/Preloader';

import { App } from '@components/App';

import { INIT_CONFIG, keycloak } from './auth';
import { reportWebVitals } from './reportWebVitals';

import './styles/index.scss';

ReactDOM.render(
  <StrictMode>
    <ReactKeycloakProvider initOptions={INIT_CONFIG} authClient={keycloak} LoadingComponent={<Preloader />}>
      <App />
    </ReactKeycloakProvider>
  </StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
